var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"links-container"},[_c('div',{staticClass:"series"},_vm._l((_vm.linkArray),function(item,index){return _c('span',{key:index,staticClass:"link",on:{"click":function($event){return _vm.link(item)}}},[_c('img',{attrs:{"src":item.title,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }